import React from 'react'
import Checkable from '../Checkable'

/**
 * Awesome checkbox.
 */
const Checkbox = props => <Checkable type="checkbox" {...props} />

export default Checkbox
